<div #progressBar class="progress" [style.width.%]="max" (mousedown)="onMouse($event)" (mouseup)="onMouse($event)" (mousemove)="onMouse($event)">
    <div class="progress-bar bg-{{ type }}" [class.progress-bar-striped]="striped" [class.progress-bar-animated]="animated" [style.width.%]="value"></div>
</div>